import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import CreateSystemForm from "../../components/create-system-form";
import WithNavigation from "../../hoc/with-navigation";
import { useSystem } from "../../store/system";

import "./styles.css";

const CreateSystem: React.FC = () => {
	const history = useHistory();
	const systemStore = useSystem();

	const handleSubmit = (data) => {
		systemStore.create(data.name, data.length, data.power);
	};

	useEffect(
		() => () => {
			systemStore.reset();
		},
		[]
	);

	useEffect(() => {
		if (systemStore.createdSystemId) {
			history.replace(`/system/${systemStore.createdSystemId}`);
		}
	}, [systemStore.createReqInfo]);

	return (
		<WithNavigation checkUser={true} preventGoBack={false} text="TVM">
			<CreateSystemForm onSubmit={handleSubmit} />
		</WithNavigation>
	);
};

export default CreateSystem;
